import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { RHFTextField, RHFUpload } from "../../components/hook-form";
import FormProvider from "../../components/hook-form/FormProvider";
import { fetchEvent } from "../../redux/slices/eventSlice";
import {
  createMenu,
  deleteMenuImage,
  updateMenu,
} from "../../redux/slices/menuSlice";

const Form = ({ handleClose, data, isEdit = false }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [gallery, setGallery] = useState([]);

  const createMenuLoading = useSelector((state) => state.menu.isLoading);

  const Schema = Yup.object().shape({});

  const defaultValues = useMemo(
    () => ({
      name: data?.name || "",
      media: data?.images || [],
    }),
    [data]
  );

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const { handleSubmit, watch, setValue } = methods;
  const values = watch();

  useEffect(() => {
    dispatch(fetchEvent({ limit: 100, menu: 0, enqueueSnackbar }));
  }, [dispatch, enqueueSnackbar]);

  const handleDropPhoto = useCallback(
    (acceptedFiles) => {
      const files = values.media || [];
      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      );

      setGallery((prev) => [...prev, ...newFiles]);
      setValue("media", [...files, ...newFiles], { shouldValidate: true });
    },
    [setValue, values]
  );

  const onCreateMenu = (values) => {
    const formData = new FormData();

    formData.append("name", values.name);

    if (values?.media?.length) {
      values.media.forEach((file) => {
        formData.append("images", file);
      });
    }

    dispatch(createMenu({ data: formData, enqueueSnackbar, handleClose }));
  };

  const onUpdateMenu = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    if (gallery?.length) {
      gallery.forEach((file) => {
        formData.append("images", file);
      });
    }

    dispatch(
      updateMenu({
        data: formData,
        enqueueSnackbar,
        handleClose,
        id: data?.id,
      })
    );
  };

  const handleRemoveFile = (inputFile) => {

    const extractedText = inputFile?.url?.match(/(uploads\/.*)/)?.[1];

    // Remove the file from the state
    const filteredMedia = values.media?.filter(
      (file) => file?.url !== inputFile?.url
    );
    setValue("media", filteredMedia);
    if (!inputFile?.url) {
      return;
    }
    // Dispatch the update action, sending only the mediaToRemove field
    if (inputFile) {
      dispatch(
        deleteMenuImage({
          media: true,
          data: { mediaToRemove: extractedText },
          enqueueSnackbar,
          handleClose,
          id: inputFile?.id,
        })
      );
    }
  };

  return (
    <Box p={3}>
      <FormProvider
        methods={methods}
        onSubmit={handleSubmit(isEdit ? onUpdateMenu : onCreateMenu)}
      >
        <Stack flexDirection={"row"} justifyContent={"center"} mb={2}></Stack>
        <RHFTextField name={"name"} label={"Name"} />

        <Box mt={3}>
          <p className="mb-3">Menu *</p>
          <RHFUpload
            multiple
            thumbnail
            name="media"
            maxSize={1}
            onDrop={handleDropPhoto}
            onRemove={handleRemoveFile}
          />
        </Box>

        <Stack mt={2} alignItems={"end"}>
          <LoadingButton
            loading={createMenuLoading}
            disabled={createMenuLoading}
            type="submit"
            variant="contained"
            className="!bg-primary w-fit"
          >
            {isEdit ? "Update Menu" : "Create Menu"}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default Form;
